<template>
  <div class="role">
    <div class="card-container">
      <div class="card-title">
        满意度数据筛选
      </div>
      <div class="card-content">
        <a-form :form="form" @submit="getScoreStatistics">
          <a-row>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="区域"
              >
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                label="小区" :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-select
                  v-decorator="['productId']"
                  allow-clear
                  show-search
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-form-item>
                <a-button type="primary" class="mr8" html-type="submit">
                  查询
                </a-button>
                <a-button @click="resetForm">
                  重置
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="home-up">
      <div class="home-top">
        <div class="list">
          <div v-for="(item, index) in deliveryData" :key="index" class="item">
            <div class="item-r">
              <div>
                {{ item.title }}
              </div>
              <div>当日满意度</div>
              <div>{{ item.num }}%</div>
            </div>
            <div style="margin:0 25px;"></div>
            <div>
              <a-progress
                type="circle" :percent="parseInt(item.num)" :stroke-width="10"
                :stroke-color="item.color"
              >
                <template #format="format">
                  <span v-if="index === 0" style="color: #44b5fd">100%</span>
                  <span v-if="index === 1" style="color: #7a8dfd">100%</span>
                  <span v-if="index === 2" style="color: #3175f7">100%</span>
                  <span v-if="index === 3" style="color: #51c4e5">100%</span>
                </template>
              </a-progress>
              <!-- 87CEFA -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="phoCenter">
      <div v-for="(item,index) in tutitle" :key="index" class="allecharts">
        <div class="one">
          <div class="tit_top">
            <div class="p">
              {{ item.title }}
            </div>
            <div class="a">
              <!-- ...arguments -->
              <a-radio-group default-value="1" button-style="solid" @change="onChange(...arguments,item.domname,index)">
                <a-radio-button value="1">
                  本周
                </a-radio-button>
                <a-radio-button value="2">
                  本月
                </a-radio-button>
                <a-radio-button value="3">
                  全年
                </a-radio-button>
              </a-radio-group>
            </div>
          </div>
          <div class="ech_bottom">
            <div :id="item.domname" :style="{width: '100%', height: '350px'}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EleResize } from '@/utils/esresize.js'
import * as echarts from 'echarts'
import {
  getTidy,
  getConvenient,
  getStandard,
  getQuality,
  getScoreStatistics,
  getPointList
} from '@/api/statistics'
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      estateList: [],
      pointList: [],
      region: [],
      options: [],
      deliveryData: [
        {
          title: '环境整洁',
          num: '0',
          color: '#44B5FD'
        },
        {
          title: '设备体验',
          num: '0',
          color: '#7A8DFD'
        },
        {
          title: '运营规范',
          num: '0',
          color: '#3175F7'
        },
        {
          title: '空气质量',
          num: '0',
          color: '#51C4E5'
        }
      ],
      tutitle: [
        {
          title: '环境满意度',
          domname: 'environment'
        },
        {
          title: '设备体验满意度',
          domname: 'experience'
        },
        {
          title: '运营规范满意度',
          domname: 'standard'
        },
        {
          title: '空气质量满意度',
          domname: 'air'
        }
      ],
      environment_eCharts: null,
      experience_eCharts: null,
      standard_echarts: null,
      air_echarts: null,

      environment: [],
      environment_s: [],
      experience: [],
      experience_s: [],
      standard: [],
      standard_s: [],
      air: [],
      air_s: [],
      changeValue1: 1,
      changeValue2: 1,
      changeValue3: 1,
      changeValue4: 1,
      form: this.$form.createForm(this, {}),
      indexs: null
    }
  },
  created () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getTidy()
        this.getConvenient()
        this.getStandard()
        this.getQuality()
      }, 50)
    })
  },
  mounted () {
    this.getScoreStatistics()
    this.getArea('', 2)
    this.getEstate()
    this.getTidy()
    this.getConvenient()
    this.getStandard()
    this.getQuality()
    // this.getPointList()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    getPointList () {
      const params = {
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        streetId: this.region[3] || ''
      }
      getPointList(params).then(res => {
        this.pointList = res.result
      })
    },
    changeArea (areasId) {
      this.estateList = []
      this.form.setFieldsValue({ productId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
      this.getPointList()
    },
    // 选择 本周 本月 全年
    onChange (event, domname, index) {
      this.indexs = index
      console.log(event, index, 'valuevaluevalue')
      const value = event.target.value
      if (index === 0) {
        this.changeValue1 = value
      } else if (index === 1) {
        this.changeValue2 = value
      } else if (index === 2) {
        this.changeValue3 = value
      } else if (index === 3) {
        this.changeValue4 = value
      }

      if (domname === 'standard') this.getStandard()
      if (domname === 'environment') this.getTidy()
      if (domname === 'experience') this.getConvenient()
      if (domname === 'air') this.getQuality()
    },
    getScoreStatistics (e) {
      if (e) {
        e.preventDefault()
      }
      const params = {
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        streetId: this.region[3] || '',
        estateId: this.form.getFieldValue('productId') || ''
      }
      setTimeout(() => {
        this.getTidy()
        this.getConvenient()
        this.getStandard()
        this.getQuality()
      }, 50)
      getScoreStatistics(params).then(res => {
        this.deliveryData[0].num = res.result.tidyPraiserate || 0
        this.deliveryData[1].num = res.result.convenientPraiserate || 0
        this.deliveryData[2].num = res.result.standardPraiserate || 0
        this.deliveryData[3].num = res.result.qualityPraiserate || 0
      })
    },
    getTidy () {
      const params = {
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        type: this.changeValue1 || 1,
        estateId: this.form.getFieldValue('productId') || ''
      }
      params.streetId = this.region[3] || ''
      getTidy(params).then(res => { // 内外部环境满意度
        const arr = res.result
        const villArr = []
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          arr1.push(item.value)
          arr2.push(item.field)
          return
        })
        villArr.push(arr1, arr2)
        this.environment = villArr[0]
        this.environment_s = villArr[1]
        this.environmentECharts()
      })
    },
    getConvenient () {
      const params = {
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        type: this.changeValue2 || 1,
        estateId: this.form.getFieldValue('productId') || ''
      }
      params.streetId = this.region[3] || ''
      getConvenient(params).then(res => { // 设备体验满意度
        const arr = res.result
        const villArr = []
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          arr1.push(item.value)
          arr2.push(item.field)
          return
        })
        villArr.push(arr1, arr2)
        this.experience = villArr[0]
        this.experience_s = villArr[1]
        this.experienceECharts()
      })
    },
    getStandard () {
      const params = {
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        type: this.changeValue3 || 1,
        estateId: this.form.getFieldValue('productId') || ''
      }
      params.streetId = this.region[3] || ''
      getStandard(params).then(res => { // 运营规范满意度
        const arr = res.result
        const villArr = []
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          arr1.push(item.value)
          arr2.push(item.field)
          return
        })
        villArr.push(arr1, arr2)
        this.standard = villArr[0]
        this.standard_s = villArr[1]
        this.standardECharts()
      })
    },
    getQuality () {
      const params = {
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        type: this.changeValue4 || 1,
        estateId: this.form.getFieldValue('productId') || ''
      }
      params.streetId = this.region[3] || ''
      getQuality(params).then(res => { // 空气质量满意度
        const arr = res.result
        const villArr = []
        const arr1 = []
        const arr2 = []
        arr.map(item => {
          arr1.push(item.value)
          arr2.push(item.field)
          return
        })
        villArr.push(arr1, arr2)
        this.air = villArr[0]
        this.air_s = villArr[1]
        this.airECharts()
      })
    },
    environmentECharts () {
      if (environment_eCharts != null && environment_eCharts !== '' && environment_eCharts !== undefined) {
        environment_eCharts.dispose()
      }
      const chartDom = document.getElementById('environment')
      const environment_eCharts = echarts.init(chartDom)
      const option = {
        grid: {
          height: '65%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.environment,
          axisLabel: {
            formatter: function (value) {
              return value + '星'
            }
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: 'value',
          offset: 20,
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }

        },
        series: [{
          data: this.environment_s,
          type: 'line',
          areaStyle: {},
          smooth: true,
          symbol: 'none',
          itemStyle: {
            color: 'rgba(68,181,253,0.6)',
            opacity: 0.6,
            lineStyle: {
              width: 6// 设置线条粗细
            }
          }
        }]
      }
      // window.onresize = myChart.resize //  屏幕自适应
      const listener = function () {
        environment_eCharts.resize()
      }
      // window.addEventListener('resize', listener)
      EleResize.on(document.getElementById('environment'), listener)
      environment_eCharts.setOption(option)
    },

    experienceECharts () {
      if (experience_eCharts != null && experience_eCharts !== '' && experience_eCharts !== undefined) {
        experience_eCharts.dispose()
      }
      const chartDom = document.getElementById('experience')
      const experience_eCharts = echarts.init(chartDom)
      const option = {
        grid: {
          height: '65%'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.experience,
          axisLabel: {
            formatter: function (value) {
              return value + '星'
            }
          }
        },
        yAxis: {
          type: 'value',
          offset: 20,
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [{
          data: this.experience_s,
          type: 'line',
          areaStyle: {},
          smooth: true,
          symbol: 'none',
          itemStyle: {
            color: 'rgba(122, 141, 253, 0.6)',

            lineStyle: {
              width: 6// 设置线条粗细
            }
          }
        }]
      }
      // window.onresize = myChart.resize //  屏幕自适应
      const listener = function () {
        experience_eCharts.resize()
      }
      // window.addEventListener('resize', listener)
      EleResize.on(document.getElementById('experience'), listener)
      experience_eCharts.setOption(option)
    },

    standardECharts () {
      if (standard_echarts != null && standard_echarts !== '' && standard_echarts !== undefined) {
        standard_echarts.dispose()
      }
      const chartDom = document.getElementById('standard')
      const standard_echarts = echarts.init(chartDom)
      const option = {
        grid: {
          height: '65%'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.standard,
          axisLabel: {
            formatter: function (value) {
              return value + '星'
            }
          }

        },
        yAxis: {
          type: 'value',
          offset: 20,
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [{
          data: this.standard_s,
          type: 'line',
          areaStyle: {},
          smooth: true,
          symbol: 'none',
          itemStyle: {
            color: 'rgba(49,117,247,0.6)',

            lineStyle: {
              width: 6// 设置线条粗细
            }
          }
        }]
      }
      // window.onresize = myChart.resize //  屏幕自适应
      const listener = function () {
        standard_echarts.resize()
      }
      // window.addEventListener('resize', listener)
      EleResize.on(document.getElementById('standard'), listener)
      standard_echarts.setOption(option)
    },

    airECharts () {
      if (air_echarts != null && air_echarts !== '' && air_echarts !== undefined) {
        air_echarts.dispose()
      }
      const chartDom = document.getElementById('air')
      const air_echarts = echarts.init(chartDom)
      const option = {
        grid: {
          height: '65%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.air,
          axisLabel: {
            formatter: function (value) {
              return value + '星'
            }
          }
        },
        tooltip: {
          trigger: 'axis'
          // formatter: function (params) {
          //   let str = params.name + '星' + '<br />'
          //   str += '<span style="margin-left:10px;">' + '运营效率提升' + '  ' + '<span style="color:#24D5E1;font-size:15px;font-weight:600">' + params[0].data + '%' + '</span>' + '</span>'
          //   return str
          // }
        },
        yAxis: {
          type: 'value',
          offset: 20,
          minInterval: 1,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [{
          data: this.air_s,
          type: 'line',
          areaStyle: {},
          smooth: true,
          symbol: 'none',
          itemStyle: {
            color: 'rgba(81,196,229,0.6)',

            lineStyle: {
              width: 6// 设置线条粗细
            }
          }
        }]
      }
      // window.onresize = myChart.resize //  屏幕自适应
      const listener = function () {
        air_echarts.resize()
      }
      // window.addEventListener('resize', listener)
      EleResize.on(chartDom, listener)
      air_echarts.setOption(option)
    },
    resetForm () {
      this.form.resetFields()
      this.region = []
      this.getEstate()
      this.getScoreStatistics()
    }
  }
}
</script>
<style scoped>
.ant-progress-text{
      color: #52c41a;
}
</style>
<style lang="stylus">
.role-modal .ant-modal-footer
  text-align center
.del-modal .ant-btn-primary
  display none
</style>
<style lang="stylus" scoped>
.ant-radio-button-wrapper
  border none
.ant-radio-button-wrapper:not(:first-child)::before
  content none
.home-up
    width 100%
    display flex
    .home-top
      width 100%
      .list
        display flex
        width 100%
        justify-content space-between
        .item
          width 24%;
          height 148px
          background #FFFFFF
          border-radius 10px
          display flex
          justify-content center
          align-items center
          .item-r
            font-size 16px
            color #666666
            div:nth-child(1)
              color: #202020;
            div:nth-child(2)
              font-size 12px
            div:last-child
              font-size 30px
              color #202020
              font-weight bold
              span
                font-size 13px
                font-weight 500
                padding-left: 9px;
                box-sizing: border-box;
.phoCenter
    display: flex;
    width: 100%;
    margin-top: 20px;
    gap:20px;
    flex-wrap: wrap;
    .allecharts
      width: 49%;
      margin: auto;
    .one
      background: #fff;
      height 380px
      border-radius: 5px;
      .tit_top
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #DDDDDD;
        .a
          display: flex;
          div:nth-child(2)
            padding: 0 10px;
      .ech_bottom
        width 100%
    .two
      background: #fff;
      width: 50%;
</style>
